import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fc51e5e0&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fc51e5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc51e5e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc51e5e0')) {
      api.createRecord('fc51e5e0', component.options)
    } else {
      api.reload('fc51e5e0', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fc51e5e0&scoped=true&", function () {
      api.rerender('fc51e5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CiEb1gCe2OFD/JS/comp/DocBox.vue"
export default component.exports